/**
 * The app's three workspaces: the translation app every account has, the PM workspace, and the
 * back office. Each has its own shell; the switcher in their headers moves between them.
 */
export enum WorkspaceEnum {
  Translation = "translation",
  Pm = "pm",
  BackOffice = "backOffice",
}

const isUnder = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`)

/** The workspace a page belongs to. Everything outside `/pm` and `/admin` is the translation app. */
export const workspaceOf = (pathname: string): WorkspaceEnum => {
  if (isUnder(pathname, "/pm")) return WorkspaceEnum.Pm
  if (isUnder(pathname, "/admin")) return WorkspaceEnum.BackOffice
  return WorkspaceEnum.Translation
}

type WorkspaceAudience = { isAdmin: boolean; isStaff: boolean }

/**
 * Whether the PM workspace is offered.
 *
 * It is not built yet, so it is shown to internal staff only, and both gates must agree: an admin
 * role (super, lead PM or associate PM, from the token) and a staff account (the server's staff
 * email-domain check). Either alone is not enough -- a role is assigned by hand and can be given
 * to the wrong account, and a staff address alone includes people who do not run projects.
 */
export const canEnterPmWorkspace = ({ isAdmin, isStaff }: WorkspaceAudience) =>
  isAdmin && isStaff

/** The workspaces an account can enter, in the order the switcher lists them. */
export const availableWorkspaces = (audience: WorkspaceAudience) => [
  WorkspaceEnum.Translation,
  ...(canEnterPmWorkspace(audience) ? [WorkspaceEnum.Pm] : []),
  ...(audience.isAdmin ? [WorkspaceEnum.BackOffice] : []),
]
